import { styled } from "@mui/material/styles";

export const StyledContent = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "20px",
  height: "100%",
}));
